import { useEffect, useState } from 'react'

import { ALBUM_DETAIL, ALBUM_PAGEVIEW } from './../constants'
import { GtmAgent } from './GtmAgent'

export const useGtmAlbumPageView = (album, photos, photoUrlId = null) => {
  const [initialPageViewSent, setInitialPageViewSent] = useState(false)
  const [prevPhotoUrlId, setPrevPhotoUrlId] = useState(null)
  useEffect(() => {
    const genPageViewData = () => {
      if (!album || !photos) {
        return null
      }

      if (photoUrlId) {
        const photo = photos?.find((p) => p.urlId === photoUrlId)
        return {
          event: ALBUM_DETAIL,
          photo_tag: photo?.tags?.map((tag) => tag.urlId).join(','),
          photo_id: photo?.urlId,
          album_id: album?.urlId,
        }
      }
      return {
        event: ALBUM_PAGEVIEW,
        photo_tag: album.frontCover?.tags?.map((tag) => tag.urlId).join(','),
        album_id: album?.urlId,
      }
    }

    if (!initialPageViewSent || prevPhotoUrlId !== photoUrlId) {
      const data = genPageViewData()
      if (data !== null) {
        GtmAgent.directSendToGTM(data)
        setPrevPhotoUrlId(photoUrlId)
        if (!initialPageViewSent) {
          setInitialPageViewSent(true)
        }
      }
    }
  }, [album, photos, photoUrlId])
}
